<template>
  <div class="player">
    <video width="100%"
      poster="/img/poster.gif"
      controls>
      <source :src="itemView.urlPath"
        :type="itemView.type">
    </video>
  </div>
</template>
<script lang="ts">
import { ref, watch } from '@vue/composition-api';
import {
  BFormGroup,
  BFormInput,
  BButton,
} from 'bootstrap-vue';
export default {
  components: {
    BFormGroup,
    BFormInput,
    BButton,
  },
  props: {
    itemView: {
      type: Object,
      default: null,
    },
  },
};
</script>
